import { ChangeEvent, useContext, useState } from 'react'
import { InputText } from 'primereact/inputtext'
import { Checkbox } from 'primereact/checkbox'
import { Button } from 'primereact/button'
import '../styles/css/stl-login.css'
import { useNavigate } from 'react-router-dom'
import { CommonContext } from '../component/common/context/commonContext'
import axios from 'axios'
import { onKeyDownCheckEnter } from '../utils/inputText'
import { getBrand } from '../utils/tenant'

function Login() {
    const { $alert } = useContext(CommonContext)
    const navigate = useNavigate()
    const [loginId, setLoginId] = useState<string>(localStorage.getItem('rdmsLoginId') ? localStorage.getItem('rdmsLoginId') || '' : '')
    const [pass, setPass] = useState<string>('')
    const [rememberMe, setRememberMe] = useState(!!localStorage.getItem('rdmsLoginId'))

    const onChangeLoginId = (event: ChangeEvent<HTMLInputElement>) => {
        setLoginId(event.currentTarget.value)
    }

    const onChangePass = (event: ChangeEvent<HTMLInputElement>) => {
        setPass(event.currentTarget.value)
    }
    const onClickLogin = async () => {
        if (!loginId) {
            $alert({
                title: '실패',
                text: 'ID를 입력하여 주십시오.',
                icon: 'warn',
            })
            return
        }

        if (!pass) {
            $alert({
                title: '실패',
                text: '패스워드를 입력하여 주십시오.',
                icon: 'warn',
            })
            return
        }

        const { data: myIp } = await axios.get('https://api64.ipify.org?format=json')
        const { data } = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/user/login`,
            { loginId, pass },
            {
                headers: {
                    'client-ip': myIp['ip'],
                },
            },
        )
        const { status, error, data: res } = data

        if (status === 401) {
            $alert({
                title: '실패',
                text: error,
                icon: 'warn',
            })
        } else if (status === 200) {
            const { token } = res
            localStorage.setItem('rdmsToken', `Bearer ${token}`)
            localStorage.setItem('rdmsMyIp', myIp['ip'])

            if (rememberMe) {
                localStorage.setItem('rdmsLoginId', loginId)
            } else {
                localStorage.setItem('rdmsLoginId', '')
            }
            navigate('/customer/sales/sales-list')
        }
    }

    return (
        <div className="stl-login-container">
            <div className="stl-login-shell">
                {/* 왼쪽 패널 - 로그인 섹션 */}
                <div className="stl-login-left-panel">
                    <div className="stl-login-form-wrapper">
                        {/* 섹션 1: 로고 + 슬로건 */}
                        <div className="stl-login-section-1">
                            <div className="stl-login-logo-area">
                                <img src="/stl_logo.png" alt="STL" className="stl-login-logo-img" />
                                <p className="stl-login-logo-text">{getBrand().loginTitle}</p>
                            </div>
                            <div className="stl-login-slogan-wrapper">
                                <p className="stl-login-slogan">SMARTLY CONNECTED,</p>
                                <p className="stl-login-slogan">VALUE DELIVERED.</p>
                            </div>
                        </div>
                        {/* 섹션 2: 폼 (Account ~ Save Account) */}
                        <div className="stl-login-section-2">
                            <form className="stl-login-form" onSubmit={(e) => e.preventDefault()}>
                                <div className="stl-login-input-group">
                                    <label className="stl-login-label">Account</label>
                                    <InputText
                                        id="loginId"
                                        type="text"
                                        className="stl-login-input"
                                        placeholder="Username or E-Mail"
                                        value={loginId}
                                        onChange={onChangeLoginId}
                                        onKeyDown={(e) => onKeyDownCheckEnter(e, onClickLogin)}
                                    />
                                </div>
                                <div className="stl-login-input-group">
                                    <label className="stl-login-label">Password</label>
                                    <InputText
                                        id="pass"
                                        type="password"
                                        className="stl-login-input"
                                        placeholder="Password"
                                        value={pass}
                                        onChange={onChangePass}
                                        onKeyDown={(e) => onKeyDownCheckEnter(e, onClickLogin)}
                                    />
                                </div>
                                <div className="stl-login-checkbox-group">
                                    <Checkbox inputId="rememberMe" checked={rememberMe} onChange={(e) => setRememberMe(e.checked ?? false)} />
                                    <label htmlFor="rememberMe" className="stl-login-checkbox-label">
                                        Save Account
                                    </label>
                                </div>
                            </form>
                        </div>
                        {/* 섹션 3: 버튼 + Copyright */}
                        <div className="stl-login-section-3">
                            <div className="stl-login-button-wrapper">
                                <Button label="Sign In" className="stl-login-button" onClick={onClickLogin} type="button" />
                            </div>
                            <p className="stl-login-footer">Copyright © 2026 STL. All Rights Reserved</p>
                        </div>
                    </div>
                </div>
                {/* 오른쪽 패널 - 배경 이미지 */}
                <div className="stl-login-right-panel">
                    <img src="dnace_background_img.jpg" alt="Login Background" className="stl-login-background-img" />
                </div>
            </div>
        </div>
    )
}

export default Login
